"use strict";

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = {
    /********
    	description：获取客户端当前时间年月日
    	paramter：
    		patter:【可选】年月日格式分隔符
    	version:1.0.0
    	data:2019/08/26
    	changeContent:基础版(cuishuai)
    ********/
    now: function now() {
        var patter = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "/";

        var nowDate = new Date();
        return nowDate.getFullYear() + patter + (nowDate.getMonth() + 1) + patter + nowDate.getDate();
    },

    /********
    	description：获取客户端当前时间戳
    	paramter：无
    	version:1.0.0
    	data:2019/08/26
    	changeContent:基础版(cuishuai)
    ********/
    nowstrTime: new Date().getTime(),
    /********
    	description：时间戳转年月日
    	paramter：
    		timestr:【必需】转换的时间戳
    		hms:【可选】是否返回时分秒
    		patter:【可选】时间格式化字符
    	version:1.0.0
    	data:2019/08/26
    	changeContent:基础版(cuishuai)
    ********/
    strToTime: function strToTime(timestr, hms) {
        var patter = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : "-";

        if (timestr) {
            if (timestr.toString().indexOf("-") != -1) {
                timestr = timestr.toString().replace(/-/g, '/');
            } else {
                timestr = timestr * 1;
            }

            var dateObj = new Date(timestr);
            var Y = dateObj.getFullYear();
            var M = dateObj.getMonth() + 1;
            var D = dateObj.getDate();

            var h = dateObj.getHours();
            var m = dateObj.getMinutes();
            var s = dateObj.getSeconds();
            var ymd = void 0;
            if (patter == 'string') {
                ymd = Y + "年" + (M < 10 ? '0' + M : M) + "月" + (D < 10 ? '0' + D : D) + "日";
            } else {
                ymd = Y + patter + (M < 10 ? '0' + M : M) + patter + (D < 10 ? '0' + D : D);
            }
            if (hms) {
                var hms_h = "",
                    hms_m = "",
                    hms_s = "";
                hms_h = hms.indexOf("h") != -1 ? " " + (h < 10 ? '0' + h : h) : "";
                hms_m = hms.indexOf("m") != -1 ? ":" + (m < 10 ? '0' + m : m) : "";
                hms_s = hms.indexOf("s") != -1 ? ":" + (s < 10 ? '0' + s : s) : "";
                return ymd + hms_h + hms_m + hms_s;
            } else {
                return ymd;
            }
        } else {
            return "";
        }
    },

    /********
    	description：将指定时间转为时间戳
    	paramter：
    		timestr:【必需】转换的日期
    	version:1.0.0
    	data:2019/08/26
    	changeContent:基础版(cuishuai)
    ********/
    timeToStr: function timeToStr(timestr) {
        return new Date(timestr).getTime();
    },

    /********
    	description：日期格式加减
    	paramter：
               timestr:【必需】 时间戳类型 被加/减数
               year:【必需】  加减年份 正数加 负数减
               month:【必需】 加减月份 正数加 负数减
               day:【必需】   加减天数 正数加 负数减
               patter【可选】 年月日分隔符，不传以时间戳返回
    	version:1.0.0
    	data:2020/10/09
    	changeContent:基础版(chenkailei)
    ********/

    dateChange: function dateChange(timestr) {
        var year = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
        var month = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 0;
        var day = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 0;
        var patter = arguments[4];

        if (day != 0 || !(typeof day === 'number' && !isNaN(day))) {
            timestr = this.timeToStr(this.addDays(timestr, day));
        }
        if (month != 0 || !(typeof month === 'number' && !isNaN(month))) {
            timestr = this.timeToStr(this.addMonths(timestr, month));
        }
        if (year != 0 || !(typeof year === 'number' && !isNaN(year))) {
            timestr = this.timeToStr(this.addYears(timestr, year));
        }

        if (patter) {
            return this.strToTime(timestr, null, patter);
        } else {
            return timestr;
        }
    },
    /********
    description：年份加减
    paramter：
            v:【必需】 时间戳类型 被加/减数
            n:【必需】  加减年份 正数加 负数减
            patter【可选】 年月日分隔符，不传以时间戳返回
    version:1.0.0
    data:2020/10/09
    changeContent:基础版(chenkailei)
    ********/
    addYears: function addYears(v, n, patter) {
        v = new Date(v.valueOf());
        if (v) {
            v.setFullYear(v.getFullYear() + Number(n));
            return patter ? this.strToTime(v, null, patter) : this.timeToStr(v);
        }
    },

    /********
    description：月份加减
    paramter：
            v:【必需】 时间戳类型 被加/减数
            n:【必需】  加减月份 正数加 负数减
            patter【可选】 年月日分隔符，不传以时间戳返回
    version:1.0.0
    data:2020/10/09
    changeContent:基础版(chenkailei)
    ********/
    addMonths: function addMonths(v, n, patter) {
        v = new Date(v.valueOf());
        if (v) {
            v.setMonth(v.getMonth() + Number(n));
            return patter ? this.strToTime(v, null, patter) : this.timeToStr(v);
        }
    },

    /********
    description：天数加减
    paramter：
            v:【必需】 时间戳类型 被加/减数
            n:【必需】  加减天数 正数加 负数减
            patter【可选】 年月日分隔符，不传以时间戳返回
    version:1.0.0
    data:2020/10/09
    changeContent:基础版(chenkailei)
    ********/
    addDays: function addDays(v, n, patter) {
        v = new Date(v.valueOf());
        if (v) {
            v.setDate(v.getDate() + Number(n));
            return patter ? this.strToTime(v, null, patter) : this.timeToStr(v);
        }
    },


    /********
    description：时间差
    paramter：
            start:【必需】  开始时间戳
            end:【必需】    结束时间戳
            format:【选填】 day: 返回天数
                            time:返回时间戳
    version:1.0.0
    data:2020/11/26
    changeContent:基础版(chenkailei)
    ********/
    timeDiff: function timeDiff(start, end) {
        var format = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : "day";

        if (start && end) {
            var diff = Math.abs(start - end);
            switch (format) {
                case "time":
                    diff = diff;
                    break;
                case "day":
                    diff = diff / (1000 * 3600 * 24);
                    break;
                default:
                    diff = diff;
                    break;
            }
            return diff ? Math.ceil(diff) : "";
        }
    },


    // 毫秒或秒转为对应时长
    // time  要转换的时间戳
    // isSecond   是否是秒
    strToDuration: function strToDuration(time) {
        var isSecond = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

        if (isSecond) {
            var result = parseInt(time);
            var h = Math.floor(result / 3600) < 10 ? '0' + Math.floor(result / 3600) : Math.floor(result / 3600);
            var m = Math.floor(result / 60 % 60) < 10 ? '0' + Math.floor(result / 60 % 60) : Math.floor(result / 60 % 60);
            var s = Math.floor(result % 60) < 10 ? '0' + Math.floor(result % 60) : Math.floor(result % 60);
            var res = '';
            if (h !== '00') {
                res += h + ":";
            } else {
                res += "00:";
            };
            if (m !== '00') {
                res += m + ":";
            } else {
                res += "00:";
            };
            res += "" + s;
            return res;
        } else {
            var hours = Math.floor(time % 86400000 / 3600000); //时
            var minutes = Math.floor(time % 3600000 / 60000); //分
            var seconds = Math.floor(time % 60000 / 1000); //秒
            if (hours < 10) {
                hours = '0' + hours;
            }
            if (minutes < 10) {
                minutes = '0' + minutes;
            }
            if (seconds < 10) {
                seconds = '0' + seconds;
            }
            return '' + hours + ':' + minutes + ":" + seconds;
        }
    }
};